type AuthEvent = 'SESSION_EXPIRED' | 'LOGIN_SUCCESS';

class AuthEventEmitter extends EventTarget {
  emit(event: AuthEvent) {
    this.dispatchEvent(new Event(event));
  }

  subscribe(event: AuthEvent, cb: () => void) {
    this.addEventListener(event, cb);
    return () => this.removeEventListener(event, cb);
  }
}

export const authEvents = new AuthEventEmitter();